const PortalBaseURL = process.env.BASE_URL;
const dev = {
  PortalBaseURL,
  PortalBrowserBaseURL: '/portal',
  businessBrowserUrl: 'http://localhost:8003',
  bidBrowserUrl: 'http://localhost:8200',
  baseImgUrl: 'http://jwt.com:9083/',
  chatUrl: '//172.18.61.56:8081',
  bcsBrowserUrl: '//bcs.jstec.com.cn',
  proxy: {
    '/portal': {
      target: PortalBaseURL,
      cookieDomainRewrite: 'localhost',
    },
    '/file': {
      target: PortalBaseURL,
    },
  },
};

export default dev;
